import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { OTHER_OPTION, type FieldControlSpec, type FieldControlState } from './field-control-state';

interface TemplateFieldControlProps {
  id: string;
  spec: FieldControlSpec;
  state: FieldControlState;
  onChange: (state: FieldControlState) => void;
  disabled?: boolean;
}

// The control is chosen from the field's type and options exactly as the render payload states
// them; the page never derives a type or a vocabulary of its own.
export function TemplateFieldControl({ id, spec, state, onChange, disabled }: TemplateFieldControlProps) {
  if (spec.type === 'select') {
    return (
      <div className="space-y-2">
        <Select
          value={state.value}
          onValueChange={(value) => onChange({ ...state, value })}
          disabled={disabled}
        >
          <SelectTrigger id={id} className="h-8 max-sm:h-12 max-sm:text-base">
            <SelectValue placeholder="Choose…" />
          </SelectTrigger>
          <SelectContent>
            {(spec.options ?? []).map((option) => (
              <SelectItem key={option} value={option} className="max-sm:min-h-12 max-sm:text-base">
                {option}
              </SelectItem>
            ))}
            {spec.allowOther === true ? (
              <SelectItem value={OTHER_OPTION} className="max-sm:min-h-12 max-sm:text-base">
                Other…
              </SelectItem>
            ) : null}
          </SelectContent>
        </Select>
        {state.value === OTHER_OPTION ? (
          <Input
            value={state.other}
            onChange={(event) => onChange({ ...state, other: event.target.value })}
            placeholder="Other"
            disabled={disabled}
            className="h-8 max-sm:h-12 max-sm:text-base"
          />
        ) : null}
      </div>
    );
  }
  if (spec.type === 'multiline') {
    return (
      <Textarea
        id={id}
        className="max-sm:text-base"
        rows={3}
        value={state.value}
        onChange={(event) => onChange({ ...state, value: event.target.value })}
        disabled={disabled}
      />
    );
  }
  return (
    <Input
      id={id}
      type={spec.type === 'number' ? 'number' : spec.type === 'date' ? 'date' : 'text'}
      value={state.value}
      onChange={(event) => onChange({ ...state, value: event.target.value })}
      disabled={disabled}
      className="h-8 max-sm:h-12 max-sm:text-base"
    />
  );
}
